import { Ty } from '@cotera/era';
import eq from 'fast-deep-equal';
// Special case support for all of our scalar types being used as keys by value
// (Most langauges support this 😭, but JS uses object identity for things like
// arrays dates and structs, so we have to role our own)

type Key = [name: string, val: Ty.Scalar][];

export class KeyVal<V> {
  *[Symbol.iterator](): Generator<{ key: Key; val: V }> {
    for (const [key, val] of this.data) {
      yield { key, val };
    }
  }

  constructor(private readonly data: [key: Key, val: V][] = []) {}

  mapValues<Next>(cb: (current: V) => Next): KeyVal<Next> {
    return new KeyVal(this.data.map(([key, val]) => [key, cb(val)]));
  }

  insertWithPrevious(key: Key, cb: (original: V | undefined) => V): void {
    const previous = this.get(key);
    const next = cb(previous);
    return this.insert(key, next);
  }

  insert(key: Key, v: V): void {
    const existing = this.data.find(([k, _val]) => eq(k, key));
    if (existing !== undefined) {
      existing[1] = v;
    } else {
      this.data.push([key, v]);
    }
  }

  get(key: Key): V | undefined {
    return this.data.find(([k, _val]) => eq(k, key))?.[1];
  }
}
